import MuiChip, { ChipProps as MuiChipProps } from "@material-ui/core/Chip";
import { ChipTypeMap as MuiChipTypeMap } from "@material-ui/core/Chip/Chip";
import { OverridableComponent, OverrideProps } from "@material-ui/core/OverridableComponent";
import React from "react";
import { HasTestId } from "../../types";
import { doNothing, isDefined } from "../../util";

export interface ChipTypeMap<PropsT = unknown, ComponentT extends React.ElementType = "div"> {
    props: Omit<MuiChipTypeMap<PropsT, ComponentT>["props"], "avatar" | "children" | "clickable" | "color" | "deleteIcon" | "label" | "onClick" | "onDelete" | "variant"> &
        HasTestId & {
            actionIcon?: MuiChipProps["deleteIcon"];
            label: MuiChipProps["label"];
            onAction?: MuiChipProps["onDelete"];
        };
    defaultComponent: MuiChipTypeMap<PropsT, ComponentT>["defaultComponent"];
    classKey: MuiChipTypeMap<PropsT, ComponentT>["classKey"];
}

export type ChipProps<ComponentT extends React.ElementType = ChipTypeMap["defaultComponent"], PropsT = unknown> = OverrideProps<ChipTypeMap<PropsT, ComponentT>, ComponentT>;

export const Chip = React.forwardRef(
    <ComponentT extends React.ElementType = ChipTypeMap["defaultComponent"], PropsT = unknown>(
        { actionIcon, disabled, onAction, testId, ...props }: ChipProps<ComponentT, PropsT>,
        ref: ChipProps["ref"],
    ): React.ReactElement<ChipProps<ComponentT, PropsT>> => {
        return (
            <MuiChip
                clickable={false}
                data-testid={testId}
                deleteIcon={actionIcon}
                disabled={disabled}
                onDelete={disabled && isDefined(onAction) ? doNothing : onAction}
                ref={ref}
                variant="outlined"
                {...props}
            >
                {undefined}
            </MuiChip>
        );
    },
) as OverridableComponent<ChipTypeMap>;
